define('lq/events/actions/popupGoogleLogin',[
    'lq',
    'lq/events/actions/eventAction',
    'lq/queryString'
], function (lq, EventAction, queryString) {
    'use strict';

    function PopupGoogleLogin(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(PopupGoogleLogin, EventAction);

    PopupGoogleLogin.typeName = 'PopupGoogleLogin';

    PopupGoogleLogin.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    PopupGoogleLogin.prototype.execute = function (continuation, eventActionResponse) {
        require([
            'https://apis.google.com/js/platform.js'
        ], this.signIn.bind(this, continuation));
    };

    PopupGoogleLogin.prototype.signIn = function (continuation) {
        gapi.load('auth2', this.onGapiLoaded.bind(this, continuation));
    };

    PopupGoogleLogin.prototype.onGapiLoaded = function (continuation) {
        var options = {
            client_id: this.eventData.clientId,
            scope: 'email profile',
            response_type: 'permission'
        };

        if (this.eventData.showAccountSelectionScreen)
            options.prompt = 'select_account';

        gapi.auth2.authorize(options, this.handlePopupResponse.bind(this, continuation));
    };

    PopupGoogleLogin.prototype.handlePopupResponse = function (continuation, response) {
        if (response.error) {
            if (response.error !== 'popup_closed_by_user') {
                this.handleError('invalidCredentials', 'Unable to sign in.');
            }
        } else {
            this.piping.dispatcher.dispatch(
                'LicquidAction/GoogleLogin', {
                    actionId: this.piping.actionId,
                    commandId: this.eventData.command,
                    accessToken: response.access_token
                }, this.handleLoginResponse.bind(this, continuation));
        }
    };

    PopupGoogleLogin.prototype.handleLoginResponse = function (continuation, result) {
        if (result.status === 'Success') {
            var returnUrl = queryString.getValueOf('ReturnUrl') || lq.getTenantUrl('');

            if (this.eventIsEnabled('updatingUserProperties')) {
                var self = this;
                this.triggerEvent('updatingUserProperties', function () {
                    self.piping.dispatcher.dispatch('LicquidAction/RefreshLoggedInUser')
                        .then(function () {
                            if (self.eventIsEnabled('userLoggedIn'))
                                self.triggerEvent('userLoggedIn', continuation, returnUrl);
                            else
                                continuation();
                        });
                });
            } else if (this.eventIsEnabled('userLoggedIn')) {
                this.triggerEvent('userLoggedIn', continuation, returnUrl);
            } else {
                window.location = returnUrl;
            }
        } else {
            this.handleError('invalidCredentials', 'Unable to sign in.');
        }
    };

    PopupGoogleLogin.prototype.handleError = function (eventName, defaultMessage) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
        }
    };

    return PopupGoogleLogin;
});
